const ERROR_MESSAGE = "ERROR_MESSAGE"
const DISMISS_MESSAGES = "DISMISS_MESSAGES"

export { DISMISS_MESSAGES, ERROR_MESSAGE }
